import { Alert, Box, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { Input } from 'sharedComponents/Input';
import { QuestionLabel } from './QuestionLabel';
import { RatingQuestionProps } from './types';

export const RatingQuestion: React.FC<RatingQuestionProps> = ({
  dataTestId,
  defaultValue,
  isRequired,
  maxScore,
  onChange,
  question,
  value,
}) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const theme = useTheme();

  return (
    <Box>
      <QuestionLabel
        dataTestId={dataTestId}
        questionText={question}
        isRequired={isRequired}
        sx={{
          paddingBottom: theme.spacing(0.5),
          fontWeight: theme.typography.fontWeightMediumBold,
        }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center' }} data-testid={dataTestId}>
        <Input
          onChange={(e) => {
            setErrorMessage(null);
            const numericValue = e.target.valueAsNumber;

            if (!isNaN(numericValue) && (numericValue > maxScore || numericValue < 0)) {
              setErrorMessage('This is an invalid number');
            }

            onChange(e);
          }}
          value={value ?? defaultValue ?? ''}
          type="number"
          InputProps={{
            inputProps: {
              min: 0,
              max: maxScore,
              step: 1,
            },
            inputMode: 'numeric',
            pattern: '[0-9]',
          }}
          sx={{ width: theme.spacing(9.25), marginRight: theme.spacing(1) }}
        />
        <Typography>out of {maxScore}</Typography>
      </Box>
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
    </Box>
  );
};
